import { ApiService } from "./ApiService"

export class InvoiceGroupService {

    static uri = '/invoice-group';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static show({ id }) {
        return ApiService.get(`${this.uri}/show/${id}`);
    }
}